import '@adornis/accounting/api/AccountingAPI.js';
import '@adornis/buildify/db/GlobalSettings.js';
import '@adornis/data-view/db/export-data-view.js';
import '@adornis/filter/AdornisFilter.js';
import '@adornis/filter/aspect-schemas/AbstractAspect.js';
import '@adornis/filter/aspect-schemas/BooleanAspect.js';
import '@adornis/filter/aspect-schemas/DateTimeAspect.js';
import '@adornis/filter/aspect-schemas/ExistsAspect.js';
import '@adornis/filter/aspect-schemas/FloatAspect.js';
import '@adornis/filter/aspect-schemas/IntAspect.js';
import '@adornis/filter/aspect-schemas/ListAspect.js';
import '@adornis/filter/aspect-schemas/StringAspect.js';
import '@adornis/import-export/db/convert-config.js';
import '@adornis/import-export/db/import-job.js';
import '@adornis/prosemirror-collab/operations.js';
import '@adornis/users/db/index.js';
import '@adornis/versioned-entity/api/index.js';
import '@adornis/wiki/api/index.js';
import '@adornis/wiki/db/index.js';
import '@martinus/global-config/index.js';

// ! Beware of import order here as it produces a cylce on wrong order

import '../../../../packages/address/src/entities/Adresse.js';
import '../users/entities/person.js';
import '../users/profile/entities/BankDaten.js';
import '../users/profile/entities/ProfilDaten.js';
import '../users/profile/entities/StammDaten.js';
import '../users/students/schueler-daten.js';

import './abwesenheit.js';
import './enums/misc-enums.js';
import './enums/routes.js';
import './import-export/abwesenheiten-import.js';
import './import-export/lodas-export.js';
import './job-ticket-wrapper.js';

import '../lak/index.js';
import '../permissions/api/RoleFilterAspect.js';

import './zip-city.js';
